import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BrijjSportsStateService } from '@core/state/brijjsports-state.service';

@Component({
  selector: 'app-softball-spectator',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './softball-spectator.component.html',
  styleUrl: './softball-spectator.component.scss'
})
export class SoftballSpectatorComponent {
  private readonly state = inject(BrijjSportsStateService);

  readonly games = this.state.softballGames;
}
